export default __webpack_public_path__ + "static/media/file_blue.12c7daf6.png";